import { getCompanyInitials, getCompanyColor } from "@/lib/companyAvatar";
import { cn } from "@/lib/utils";

interface CompanyAvatarProps {
  logoUrl: string | null;
  companyName: string;
  size?: "sm" | "md" | "lg";
  className?: string;
}

const sizeClasses = {
  sm: "w-10 h-10 rounded-lg text-sm",
  md: "w-14 h-14 rounded-xl text-lg",
  lg: "w-16 h-16 rounded-xl text-xl",
};

export function CompanyAvatar({ logoUrl, companyName, size = "md", className }: CompanyAvatarProps) {
  if (logoUrl) {
    return (
      <img
        src={logoUrl}
        alt=""
        className={cn(sizeClasses[size], "object-contain shrink-0 border border-border", className)}
      />
    );
  }

  const initials = getCompanyInitials(companyName);
  const colorClass = getCompanyColor(companyName);

  return (
    <div
      className={cn(
        sizeClasses[size],
        colorClass,
        "flex items-center justify-center shrink-0 font-semibold text-white",
        className,
      )}
    >
      {initials}
    </div>
  );
}
